import { makeStyles, tokens } from "@fluentui/react-components";

export const usePrivateRouteHeaderStyles = makeStyles({
  container: {
    display: "flex",
    width: "100%",
    alignItems: "flex-start",
    marginBottom: "24px",
  },
  menuButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginLeft: "auto",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
  },
  backButton: {
    paddingInline: "0px",
    width: "fit-content",
    minWidth: "unset",
  },
  tab: {
    "&>span": {
      pointerEvents: "none",
    },
  },
  tabList: {
    marginBottom: tokens.spacingVerticalS,
  },
});
